module.exports = __webpack_public_path__ + "assetsclientes/img/error.b3bd0483.png";